import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export default function usePrompt(message: string, when = true) {
  const { navigator } = useContext(UNSAFE_NavigationContext) as any;

  useEffect(() => {
    if (!when) return;

    // @ts-ignore - Using unstable React Router API
    const unblock = navigator.block?.((tx: any) => {
      if (window.confirm(message)) {
        unblock();
        tx.retry();
      }
    });

    return unblock;
  }, [navigator, message, when]);
}
